<script lang="ts">
	import { attrValue } from '../utils/html';

	export let form = null;
	export let autocomplete = 'off';
	export let classNames = '';
</script>

<form
	{...$$restProps}
	{autocomplete}
	class={attrValue([classNames, 'space-y-3 md:space-y-4'])}
	bind:this={form}
	on:submit|preventDefault|stopPropagation
>
	<slot />
</form>
